import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Signpost from '../Signpost'


class ProjectSignpost extends Component {

    constructor(props) {
        super(props)

        this.state = {
            isVisible: false
        }

        this.config = {
            rootMargin: '100px'
        }
    }

    _lazyLoadImages() {
        const images = this.refs.image.querySelectorAll('[data-lazy]');
        images.forEach(image => {
            image.setAttribute('src', image.getAttribute('data-lazy'));
            image.removeAttribute('data-lazy');
        })
    }

    _supportsIO() {
        return 'IntersectionObserver' in window;
    }

    _observe() {
        this.observer = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.observer.unobserve(this.refs.image);
                    
                    this._lazyLoadImages();
                }
            });
        }, this.config);
    }

    componentDidMount() {
        requestAnimationFrame(() => {
            setTimeout(() => {
                this.setState({ 
                    isVisible: true 
                })
            }, 0)
            
        })


        if (this._supportsIO()) {
            this._observe(this.refs.image);
            this.observer.observe(this.refs.image);
        }
        else {
            this._lazyLoadImages();
        }
    }


    render() {
        const { isVisible } = this.state
        const { project, isActive, showOverlay } = this.props

        return (
            <Signpost className={`c-signpost c-signpost--project ${isVisible ? 'c-signpost--project-fade-in' : ''}`} key={project.slug} isActive={isActive}>
                <div className="c-signpost__columns" ref="signpost">
                    <div className="c-signpost__column c-signpost__image">
                        <Link to={`/work/${project.slug}`} title={`View ${project.title} project details`}>
                            <picture ref="image">
                                <source media="(max-width:800px)" srcSet={project.small_image} />
                                <img data-lazy={project.image} alt={project.title} width="710" height="500" />
                            </picture>                                
                        </Link>
                    </div>

                    {showOverlay ?
                        <div className="c-signpost__column c-signpost__column--single">
                            <div className="c-signpost__overlay-content u-padding">
                                <h3 className="beta u-secondary-color u-margin--bottom-half">
                                    <Link className="u-unstyled" to={`/work/${project.slug}`} title={`View ${project.title} project details`}>
                                        {project.title}
                                    </Link>
                                </h3>
                                <div className="c-signpost__list" dangerouslySetInnerHTML={{__html: project.bullet_points}}></div>
                                <Link to={'/work/' + project.slug} title={`View ${project.title} project details`} className="c-signpost__link u-margin--top u-external-link u-unstyled">View project</Link>
                            </div>
                        </div>
                    : ''}
                </div>
            </Signpost>
        )
    }
}

ProjectSignpost.defaultProps = {
    showOverlay: true
}

export default ProjectSignpost


// WEBPACK FOOTER //
// ./src/components/Project/ProjectSignpost.js